import React from "react";
import { cn } from "../Libs/Utils/utils";

export interface SpinnerProps extends React.ComponentPropsWithoutRef<"div"> {}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "w-full h-full border-2 border-white border-t-transparent rounded-full animate-spin",
        className
      )}
      {...props}
    />
  )
);

Spinner.displayName = "Spinner";

export default Spinner;
